"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadesRoot = exports.HiddenShadesCount = void 0;
var _mui = require("@ori-ui/mui");
const ShadesRoot = exports.ShadesRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1),
  height: 14,
  overflow: 'hidden'
}));
const HiddenShadesCount = exports.HiddenShadesCount = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.text.primary,
  fontSize: '1rem',
  fontWeight: theme.typography.fontWeightBold
}));
